export default __webpack_public_path__ + "static/img4@2x-16849a4d9ae579021848be5ebe060301.jpg";